var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInfoWindowClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0003 20.0013C35.0003 28.2856 28.2846 35.0013 20.0003 35.0013C11.7161 35.0013 5.00033 28.2856 5.00033 20.0013C5.00033 11.717 11.7161 5.0013 20.0003 5.0013C28.2846 5.0013 35.0003 11.717 35.0003 20.0013ZM38.3337 20.0013C38.3337 30.1265 30.1255 38.3346 20.0003 38.3346C9.8751 38.3346 1.66699 30.1265 1.66699 20.0013C1.66699 9.87608 9.8751 1.66797 20.0003 1.66797C30.1255 1.66797 38.3337 9.87608 38.3337 20.0013ZM17.0122 14.6561C16.3613 14.0052 15.306 14.0052 14.6551 14.6561C14.0043 15.307 14.0043 16.3623 14.6551 17.0131L17.6433 20.0013L14.6551 22.9895C14.0043 23.6403 14.0043 24.6956 14.6551 25.3465C15.306 25.9974 16.3613 25.9974 17.0122 25.3465L20.0003 22.3583L22.9885 25.3465C23.6394 25.9974 24.6946 25.9974 25.3455 25.3465C25.9964 24.6956 25.9964 23.6403 25.3455 22.9895L22.3573 20.0013L25.3455 17.0131C25.9964 16.3623 25.9964 15.307 25.3455 14.6561C24.6946 14.0052 23.6394 14.0052 22.9885 14.6561L20.0003 17.6443L17.0122 14.6561Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfoWindowClose);
export default __webpack_public_path__ + "static/media/ic_info-window-close.818290e38debae01bc121013eb66d05f.svg";
export { ForwardRef as ReactComponent };